// Mock data for Furry Rose Road event

export const eventData = {
  title: "FURY ROSE",
  subtitle: "",
  date: "28 Août 2026",
  time: "À 18h00",
  location: {
    name: "Huldenberg",
    address: "Limburgstirumlaan 56",
    city: "Huldenberg",
    postalCode: "3040"
  },
  theme: {
    title: "Thème : Mad Max - Fury Road",
    description: "Plongez dans l'univers post-apocalyptique de Mad Max ! Préparez vos tenues les plus folles : cuir, chaînes, goggles, et style wasteland warrior. Que la route vous soit favorable !",
    dresscode: "Tenue inspirée de l'univers Mad Max : cuir, métal, style post-apocalyptique"
  },
  images: {
    hero: "/hero-bg.png",
    gallery: [
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/4ir1gosc_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/5ryimp8q_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/9mny00ye_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/6g26nzm4_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/w9ehln9l_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/1gz4z4vd_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/yybk79bs_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/n68zk10g_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/kissgoqm_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/pdia096k_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/x879asga_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/mffpetas_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/72p93mt6_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/6ovfbvkn_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/7de1xqka_image.png", caption: "" },
      { url: "https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/b4lewco5_image.png", caption: "" }
    ]
  },
  contact: {
    email: "rosedelimburgstirum@gmail.com",
    phone: "+32474413570",
    organizer: "Rose"
  }
};

export const mockRSVPs = [];
